import { UpdateAssetRequest } from '@/api/generatedApi';
import { LIST_FOLDER_CONTENTS_QUERY_KEY } from '@/hooks/api/folders/useFetchFolderContents';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CROSS_TENANT_ASSETS_GEOMETRIC_SEARCH_QUERY_KEY } from '../crossTenant/assetsGeometricSearch/query';
import { CROSS_TENANT_ASSETS_PART_SEARCH_QUERY_KEY } from '../crossTenant/assetsPartSearch/query';
import { CROSS_TENANT_ASSETS_VISUAL_SEARCH_QUERY_KEY } from '../crossTenant/assetsVisualSearch/query';
import { CROSS_TENANT_TEXT_SEARCH_QUERY_KEY } from '../crossTenant/textsearch/query';
import { CROSS_TENANT_VISUAL_SEARCH_QUERY_KEY } from '../crossTenant/visualSearch/query';
import { GET_ASSET_QUERY_KEY } from './useGetAsset';

export const useUpdateAsset = () => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { mutate, mutateAsync, isPending, error } = useMutation({
    mutationFn: ({ assetId, data }: { assetId: string; data: UpdateAssetRequest }) =>
      api.assets.updateAsset(tenantId, assetId, data),
    onSuccess: (_data, { assetId }) => {
      queryClient.resetQueries({ queryKey: [GET_ASSET_QUERY_KEY, { assetId }] });
      queryClient.resetQueries({
        queryKey: [LIST_FOLDER_CONTENTS_QUERY_KEY],
        exact: false,
      });
      queryClient.resetQueries({ queryKey: [CROSS_TENANT_TEXT_SEARCH_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [CROSS_TENANT_VISUAL_SEARCH_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [CROSS_TENANT_ASSETS_GEOMETRIC_SEARCH_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [CROSS_TENANT_ASSETS_PART_SEARCH_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [CROSS_TENANT_ASSETS_VISUAL_SEARCH_QUERY_KEY], exact: false });
    },
  });

  return {
    updateAsset: mutate,
    updateAssetAsync: mutateAsync,
    isUpdating: isPending,
    updateError: getApiError(error),
  };
};
